import { postReq } from '../utils/request'
import { Response } from '../types/api'
import { CollectionPlace } from '../types/data'

export default {
	login: (data: object): Response<CollectionPlace & { token: string }> => postReq('/api/web/authorization/login', data)
}
